import { SymptomCardData } from 'features/patient/_components/symptom-card/types';
import { round } from 'lodash';
import { values, isNil } from 'lodash/fp';
import { DateDataCollection } from './patient-info-slice-types';

/**
 * Helper method to transform an array of symptom-like
 * objects to SymptomCardData
 *
 * @param keysObj
 * @param iterable
 * @returns
 */
export function transformToSymptomCardData(
  keysObj: Record<string, any>,
  iterable: DateDataCollection[]
): Record<string, SymptomCardData[]> {
  // Iterate through the keys object
  return values(keysObj).reduce(
    (acc, name) => ({
      // Use the values of the previous iteration
      ...acc,
      // Create a new sub-object with the current key
      [name]: iterable
        // Find all objects whe
        .filter(topLevelObject => !isNil(topLevelObject[name]?.value))
        .map(
          topLevelObject =>
            ({
              date: topLevelObject.date,
              value: round(topLevelObject[name]!.value, 1)
            } as SymptomCardData)
        )
    }),
    {}
  );
}
